import { createSlice } from '@reduxjs/toolkit'
import { openSnackBar }  from './snackBarReducer'
import { aiService } from '../services/ai.service'

export const aiSlice = createSlice({
    name: 'ai',
    initialState: {
        deletedurls: [],
        termdeletedurls: [],
        warninfos: [],
        imageScans: [],
        termScans: [],
    },
    reducers: {
        setDeletedUrls : (state, action) => {
            state.deletedurls = action.payload;
            
        },
        setTermDeletedUrls : (state, action) => {
            state.termdeletedurls = action.payload;
        },
        setWarnInfos: (state, action) => {
            console.log('warninfos', action.payload);
            state.warninfos = action.payload
        },
        setScanLogs: (state, action) => {
            state.imageScans = action.payload.imageScans || [];
            state.termScans = action.payload.termScans || [];
        },
    }
});

export const { setDeletedUrls, setTermDeletedUrls, setWarnInfos, setScanLogs } = aiSlice.actions;

export const getDeletedUrls =() => async( dispatch ) => {
    try {
        const respData = await aiService.getDelUrls();
        if ( respData.success ) dispatch(setDeletedUrls(respData.deletedurls));
    } catch (err) {
        dispatch(openSnackBar({message: err.message, status: 'error'}));
    }
}

export const getTermDeletedUrls = () => async( dispatch ) => {
    try {
        const respData = await aiService.getDelTermUrls();
        if (respData.success) dispatch(setTermDeletedUrls(respData.termdeletedurls));
    } catch (err) {
        dispatch(openSnackBar({message: err.message, status: 'error'}));
    }
}

export const getWarnInfos = () => async ( dispatch) => {
    try {
        const respData = await aiService.getWarnInfos();
        if (respData.success) dispatch(setWarnInfos(respData.warninfos));
    } catch (err) {        
        dispatch(openSnackBar({message: err.message, status: 'error'}));
    }
}

export const fetchDashboardStats = () => async (dispatch) => {
    try {
        const respData = await aiService.getDashboardStats();
        if (respData.success) return respData.stats;
        throw new Error(respData.message || 'Could not load dashboard stats');
    } catch (err) {
        if (err.status !== 401) {
            dispatch(openSnackBar({ message: err.message, status: 'error' }));
        }
        return null;
    }
};

export const getScanLogs = () => async (dispatch) => {
    try {
        const respData = await aiService.getScanLogs();
        if (respData.success) {
            dispatch(setScanLogs({
                imageScans: respData.imageScans,
                termScans: respData.termScans,
            }));
        }
    } catch (err) {
        dispatch(openSnackBar({ message: err.message, status: 'error' }));
    }
};


export const selectDeletedUrls = (state) => state.aiState.deletedurls;
export const selectTermDeletedUrls = (state) => state.aiState.termdeletedurls;
export const selectWarnInfos = (state) => state.aiState.warninfos;
export const selectImageScans = (state) => state.aiState.imageScans;
export const selectTermScans = (state) => state.aiState.termScans;

export default aiSlice.reducer;